import { render } from "./treeBtn.vue?vue&type=template&id=a78a153a"
import script from "./treeBtn.vue?vue&type=script&lang=js"
export * from "./treeBtn.vue?vue&type=script&lang=js"

import exportComponent from "D:\\childu_lms\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__